import React from 'react';

type AppButtonVariant = 'blue' | 'green' | 'red';
type AppButtonSize = 'standard' | 'compact';

type AppButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: AppButtonVariant;
  size?: AppButtonSize;
  iconOnly?: boolean;
};

const AppButton: React.FC<AppButtonProps> = ({
  variant = 'blue',
  size = 'standard',
  iconOnly = false,
  className,
  children,
  ...rest
}) => {
  const classes = [
    'app-btn',
    `app-btn-${variant}`,
    `app-btn-${size}`,
    iconOnly ? 'app-btn-icon-only' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
};

export default AppButton;

